import { ConfirmationModalComponent } from './../../shared/components/modal/confirmationModal.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { RegistrarVisitaMasivaComponent } from './registrar-visita-masiva.component';
import { TablaRegistroExcelComponent } from './tabla-registro-excel.component';
import { RegistrarVisitaMasivaRoutingModule } from './registrar-visita-masiva-routing.module';


@NgModule({
    declarations: [RegistrarVisitaMasivaComponent, TablaRegistroExcelComponent],
    imports: [
        SharedModule,
        CommonModule,
        RegistrarVisitaMasivaRoutingModule
    ],
    exports: [RegistrarVisitaMasivaComponent, TablaRegistroExcelComponent]
})
export class RegistrarVisitaMasivaModule { }
